<template>
  <div class="list-loading">
    <div v-if="loading" class="upload-spinner"></div>
    <div v-if="isEmpty" class="no-grid-content">No items are available</div>
  </div>
</template>

<script>
export default {
  name: 'ListLoading',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.list-loading {
  .no-grid-content {
    padding: 50px 20px;
    text-align: center;
    font-weight: bold;
    font-size: 1.8rem;
    width: 100%;
  }

  .upload-spinner {
    margin: 20px auto;
  }
}
</style>
